export default __webpack_public_path__ + "static/media/Highlord's Pendant of Power.beb14362.jpg";